/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./ToolbarDockDOMAPI',
	'./ToolbarDockDOM'
], function(APIFactory, ToolbarDockDOMAPI, ToolbarDockDOM){
	class ToolbarPanelDockDOM extends ToolbarDockDOM {
		initialize() {
			this._api = APIFactory.createAPI(this, [ToolbarDockDOMAPI]);

			const toolbarContainerEl = this._features.DashboardSettings.get('panelToolbarContainer');
			this._root = document.createElement('div');
			this._root.className = 'toolbarDockRoot';
			toolbarContainerEl.appendChild(this._root);
			return this.render();
		}
	}
	return ToolbarPanelDockDOM;
});
